import { render, staticRenderFns } from "./ActivityDetailsCard.vue?vue&type=template&id=2149261f&"
import script from "./ActivityDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetailsCard.vue?vue&type=style&index=0&id=2149261f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports